import type { BoxProps } from '@withjoy/joykit';

export const PHOTO_COUNT_TO_SHOW = 6;

export const ASPECT_RATIO = {
  desktop: '12/7',
  mobile: '1/1',
};

export const FULL_WIDTH_PROPERTIES: BoxProps = {
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  width: '100vw',
  overflow: 'hidden',
  // All CSS units are converted to values before doing the operation.
  // -50vw: is 50% of the viewport width
  // +50%: is 50% of the *element's* width
  //
  // it's effectively the same as setting `left: -50%; transform: translateX(50%);`
  // but we need to calculate based off the viewport, not the element's width
  left: 'calc(-50vw + 50%)',
};

// Page-width variant: constrained to the page content width instead of the viewport.
export const PAGE_WIDTH_PROPERTIES: BoxProps = {
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  left: '0',
};
